import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Automation } from '@src/app/models/automation';
import { Automationaction } from '@src/app/models/automationaction';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProjectautomationService {

  constructor(private http:HttpClient) { }

  getAutomations(organizationId: string, projectId?: string) {
        const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    if (!projectId) {
      return this.http.get<Automation[]>(environment.apiUrl+`/organization/${organizationId}/automation`, httpOptions);
    }
    // If projectId is provided, fetch automations for that specific project
    if (projectId && projectId !== 'undefined') {

      return this.http.get<Automation[]>(environment.apiUrl+`/organization/${organizationId}/automation/project/${projectId} `, httpOptions);
    
    }
    };

  createAutomation(organizationId: string, automation: Automation) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post<Automation>(environment.apiUrl+`/organization/${organizationId}/automation/`, JSON.stringify(automation), httpOptions);
  };
  updateAutomation(organizationId: string, automation: Automation) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put<Automation>(environment.apiUrl+`/organization/${organizationId}/automation/${automation.automationId}`, automation, httpOptions);
  };
  deleteAutomation(organizationId: string, automationId: string, entityId: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete(environment.apiUrl+`/organization/${organizationId}/automation/${automationId}/entity/${entityId}`, httpOptions);
  }
  getAutomationActions(organizationId: string, automationId: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Automationaction[]>(environment.apiUrl+`/organization/${organizationId}/automation/${automationId}/automationaction`, httpOptions);
  }
  createAutomationAction(organizationId: string, automationId: string, action: Automationaction) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post(environment.apiUrl+`/organization/${organizationId}/automation/${automationId}/automationaction`, JSON.stringify(action), httpOptions);
  }
  /*
   * GET /organization/{organizationId}/automationtrigger/{automationId} (get details of a specific automation trigger)
 * POST /organization/{organizationId}/automationtrigger (create a new automation trigger)
 * PUT /organization/{organizationId}/automationtrigger/{automationId} (update an existing automation trigger)
 * DELETE /organization/{organizationId}/automationtrigger/{automationId} (delete an automation trigger)
 */
  getAutomationTrigger(organizationId: string, automationId: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get(environment.apiUrl+`/organization/${organizationId}/automationtrigger/${automationId}`, httpOptions);
  }
  updateAutomationTrigger(organizationId: string, automationId: string, trigger: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put(environment.apiUrl+`/organization/${organizationId}/automationtrigger/${automationId}`, JSON.stringify(trigger), httpOptions);
  }
  createAutomationTrigger(organizationId: string, automationId: string, trigger: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post(environment.apiUrl+`/organization/${organizationId}/automationtrigger/${automationId}`, JSON.stringify(trigger), httpOptions);
  }
  deleteAutomationTrigger(organizationId: string, automationId: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete(environment.apiUrl+`/organization/${organizationId}/automationtrigger/${automationId}`, httpOptions);
  }
}
